export const VEHICLE_DATA_PILL_TRANSLATION_PREFIX = 'vehicle_data_pill';
